import { useMutation } from "@apollo/client";
import {
  TrashComplianceProgramCalibrationGroupMutation,
  TrashComplianceProgramCalibrationGroupMutationVariables,
} from "types/graphql-schema";

import deleteComplianceProgramCalibrationGroupMutation from "@apps/reporting/graphql/delete-compliance-program-calibration-group-mutation";
import getComplianceProgramCalibrationGroupsQuery from "@apps/reporting/graphql/get-compliance-program-calibration-groups-query";
import useConfirm from "@helpers/hooks/use-confirm";
import useInfoModal from "@helpers/hooks/use-info-modal";

export const useDeleteCalibrationGroup = () => {
  const {
    ConfirmationDialog: DeleteConfirmationDialog,
    confirm: confirmDelete,
  } = useConfirm(
    "Are you sure?",
    "Are you sure you want to delete this calibration group?",
  );

  const [trashCalibrationGroup, { loading: isDeleting }] = useMutation<
    TrashComplianceProgramCalibrationGroupMutation,
    TrashComplianceProgramCalibrationGroupMutationVariables
  >(deleteComplianceProgramCalibrationGroupMutation, {
    refetchQueries: [getComplianceProgramCalibrationGroupsQuery],
  });

  return {
    trashCalibrationGroup,
    isDeleting,
    DeleteConfirmationDialog,
    confirmDelete,
  };
};

// "Create group" with filters that match nobody.
export const useNoEmployeesSelectedDialog = () =>
  useInfoModal(
    "No Employees Selected",
    "There are no employees that meet the filter criteria you currently have selected. To create a calibration group, you must have at least one employee selected.",
  );
